// 商品タイトルの「Qlive for skin」の直後に改行を入れる
let element = document.querySelector('h1');
element.innerHTML = element.innerHTML.replace(/Qlive for skin/g, "Qlive for skin<br/>");
